module.exports = __webpack_public_path__ + "static/media/drukurs.9144fc3f.png";